import { useTranslation } from '@mint-lib/i18n';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerRoot,
  DrawerTitle,
} from '@mint-lib/tw-components';

import BudgetStructureCards from './BudgetStructureCards.jsx';

type BudgetStructureDrawerProps = {
  open: boolean;
  onClose: () => void;
};

const BudgetStructureDrawer = ({
  open,
  onClose,
}: BudgetStructureDrawerProps) => {
  const { t } = useTranslation('@myn/planning_v2');

  return (
    <Drawer open={open} onOpenChange={(open) => !open && onClose()}>
      <DrawerPortal>
        <DrawerOverlay />
        <DrawerRoot className="mb-2 flex w-[720px]">
          <DrawerHeader>
            <DrawerClose />
            <DrawerTitle>{t('Budget Structure')}</DrawerTitle>
          </DrawerHeader>
          <DrawerContent>
            <BudgetStructureCards />
          </DrawerContent>
        </DrawerRoot>
      </DrawerPortal>
    </Drawer>
  );
};

export default BudgetStructureDrawer;
